module.exports = __webpack_public_path__ + "img/intr@2x.540bd3fb.png";